import { all, call, put, takeEvery } from '@redux-saga/core/effects';
import { IFetchResponse } from '~utilities/fetch';
import {
    ISolicitorsListAction,
    solicitorsSetAction,
} from './actions';
import SolicitorsActionsEnum from './ActionsEnum';
import ISolicitor from '~Api/Solicitors/ISolicitor';
import { parseSolicitor } from '~Api/Solicitors/parsers';
import { solicitorsListRequest } from '~Api/Solicitors/requests';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function* solicitorsList(action: ISolicitorsListAction): Iterator<unknown> {
    const solicitorsListResponse: IFetchResponse = yield call(solicitorsListRequest);
    const solicitors: ISolicitor[] = solicitorsListResponse.body.map(parseSolicitor);
    yield put(solicitorsSetAction(solicitors));
}

export function* SolicitorsSagas(): Iterator<unknown> {
    yield all([
        takeEvery(SolicitorsActionsEnum.SolicitorsList, solicitorsList),
    ]);
}
